import React from 'react';
import axios from 'axios';

const Test = () => {
    let muid=null;
    //steps to connect
    //1.login through post request, on success muid will be returned
    //2.on success of login api, replace url in the browser with the api mentioned below, along with that pass the input object in string form
    const clickHandle=()=>{
        axios.post("https://mdev.thermalytix.com/api/login",{
           username:"hribcts@gmail.com",
           password:"rmh@nsynp2020",
	//username:"akshayareddy22111@gmail.com",
//password:"test",
            partnerid:'Remedi'
        },{withCredentials:true}).then((res)=>{

         muid=res.data.muid;
console.log("response is",res)
         
          var input={
            "patientId":"53",
            "visitId":"3938", 
             "age":34,
	"redirectUrl":"https://www.google.com"
        }
console.log(`https://mdev.thermalytix.com/api/v1/patient/${muid}?input=`+JSON.stringify(input))
       //  window.location.replace(`https://mdev.thermalytix.com/patient/${muid}?input=`+JSON.stringify(input));
        }).catch((e)=>{
            console.log("error",e)
        })
    }

    return (
        <div>
             <button onClick={clickHandle}>Login</button>
        </div>
    )
}

export default Test
